import styled from 'styled-components';

export const PreviewContainer = styled.div`
    display: flex;
    width: 100%;
    height: 200px;
    max-height: 300px;
    border-bottom: 1px solid #f0f0f0;
`;

export const ModalPreview = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 200px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    margin-bottom: 20px;
`;

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100%;
    width: 100%;
    gap: 20px;
    padding: 10px;

    
`;

export const CardsContainer = styled.div`
    display: flex;
    height: 100%;
    overflow-y: auto;
    width: 100%;
    gap: 20px;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        justify-content: center;
        & > div {
           flex-grow: 1 !important;
           min-width: 100% !important;
           height: fit-content !important;
        }
    }
`;
